export const OFFER_KINDS = ["single", "fixed_set", "pick_n"];
export function isOfferKind(v) {
    return (typeof v === "string" && OFFER_KINDS.includes(v));
}
export const WINDOW_STARTS = ["on_purchase", "on_first_play"];
export function isWindowStarts(v) {
    return (typeof v === "string" && WINDOW_STARTS.includes(v));
}
export const PORTAL_HOST_STATUSES = [
    "pending_dns",
    "pending_certificate",
    "active",
    "failed",
];
export function isPortalHostStatus(v) {
    return (typeof v === "string" &&
        PORTAL_HOST_STATUSES.includes(v));
}
export const PLAY_CONTENT = ["all", "purchased"];
export function isPlayContent(v) {
    return (typeof v === "string" && PLAY_CONTENT.includes(v));
}
export function playShowsAll(settings) {
    return (settings === null || settings === void 0 ? void 0 : settings.playContent) !== "purchased";
}
export function portalShowsSeries(settings) {
    return (settings === null || settings === void 0 ? void 0 : settings.showSeries) !== false;
}
export const PORTAL_DEFAULTS = {
    defaultLocale: "sv",
    heartbeatSeconds: 60,
    startWindowDays: 30,
    vatBps: 2500,
};
export function consumerAccountStatus(member) {
    if (member.redactedAt)
        return "redacted";
    if (!member.enabled)
        return "disabled";
    return "active";
}
export const CONSUMER_SESSION_KINDS = ["web", "app"];
export function isConsumerSessionKind(v) {
    return (typeof v === "string" &&
        CONSUMER_SESSION_KINDS.includes(v));
}
export const CONSUMER_TOKEN_KINDS = ["verify", "reset"];
export const ORDER_LINE_KINDS = ["sale", "refund"];
export const PLAY_END_REASONS = [
    "stopped",
    "taken_over",
    "expired",
    "revoked",
    "heartbeat_lost",
    "logged_out",
];
export function isPlayEndReason(v) {
    return (typeof v === "string" && PLAY_END_REASONS.includes(v));
}
